export const AM = {
  navAllergenMaster: "nav-allergen-master",
  page: "allergen-master-page",
  title: "allergen-master-title",
  banner: "allergen-master-banner",
  search: "allergen-master-search",
  statusFilter: "allergen-master-status-filter",
  typeFilter: "allergen-master-type-filter",
  table: "allergen-master-table",
  loading: "allergen-master-loading",
  emptyState: "allergen-master-empty",
  errorState: "allergen-master-error",
  row: "allergen-master-row",
  newBtn: "allergen-master-new-btn",
  editBtn: "allergen-master-edit-btn",
  activateBtn: "allergen-master-activate-btn",
  form: "allergen-master-form",
  formDisplayName: "allergen-master-field-display-name",
  formAllergenType: "allergen-master-field-type",
  formCodeSystem: "allergen-master-field-code-system",
  formCode: "allergen-master-field-code",
  formCodeDisplay: "allergen-master-field-code-display",
  formRxnorm: "allergen-master-field-rxnorm",
  formSnomed: "allergen-master-field-snomed",
  formSynonyms: "allergen-master-field-synonyms",
  formActive: "allergen-master-field-active",
  formSave: "allergen-master-save-btn",
  formCancel: "allergen-master-cancel-btn",
};
